/*eslint-disable */
import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import _toLower from 'lodash/toLower'
import remove from '../images/close.png';
import FileField from '../shared/FileField';
import { reduxForm } from 'redux-form';
import SelectField from '../shared/SelectField';
import Modal from 'react-modal';
import { GRADES } from '../../utils/const';
import getFileIcon from '../../utils/getFileIcon';
import fileIcon from '../../../src/assets/img/file.png'


const tabsType = ['task', 'result', 'review'];

class StudentProject extends Component {
  state = {
    tabIndex: 0,
    isReviewModalOpened: false,
    selectedReview: null,
    addFiles: [],
    reviewAddFiles: [],
    taskValue: '',
    resultValue: '',
    reviewValue: '',
    gradeValue: '',
  };

  hasGrade = () => {
    const { grade } = this.props;
    return grade !== null && grade !== undefined && grade !== '';
  };

  fileLoad = e => {
    const { xp_key, uploadFile } = this.props;
    const { tabIndex, selectedReview } = this.state;
    const { files } = e.target;
    // Для вкладки рецензии при добавлении новой (нет selectedReview) — не загружаем сразу (нет reviewId)
    if (tabIndex !== 2 || selectedReview) {
      files && xp_key && uploadFile(files[0], tabsType[tabIndex], xp_key);
    }
    const newFiles = e.target.files;
    if (tabIndex === 2) {
      this.setState(prev => ({ ...prev, reviewAddFiles: [...prev.reviewAddFiles, ...newFiles] }));
    } else {
      this.setState(prev => ({ ...prev, addFiles: [...prev.addFiles, ...newFiles] }));
    }
  }

  createFileAt = () => {
    const fileInput = document.getElementById('fileInput')
    fileInput.click()
  }

  componentDidMount() {
    this.props.initialize({
      task: this.props.task,
      result: this.props.result,
      grade: this.props.grade,
    });
    this.setState({
      taskValue: this.props.task || '',
      resultValue: this.props.result || '',
      gradeValue: this.props.grade === null || this.props.grade === undefined ? '' : this.props.grade,
    });
  }

  componentDidUpdate(prevProps) {
    const { task, result, reviews, grade } = this.props;
    const { selectedReview } = this.state;

    if (task !== prevProps.task && task !== this.state.taskValue) {
      this.setState({ taskValue: task || '' });
    }

    if (result !== prevProps.result && result !== this.state.resultValue) {
      this.setState({ resultValue: result || '' });
    }

    if (grade !== prevProps.grade) {
      this.props.change('grade', grade);
      this.setState({ gradeValue: grade === null || grade === undefined ? '' : grade });
    }

    if (reviews !== prevProps.reviews) {
      if (reviews && selectedReview) {
        const review = reviews.find(
          item => item.xp_key === selectedReview.xp_key
        );
        const indexReview = reviews.indexOf(review);
        this.setState({ selectedReview: reviews[indexReview] });
      }
    }
  }

  syncStateToReduxForm = () => {
    this.props.change('task', this.state.taskValue);
    this.props.change('result', this.state.resultValue);
    this.props.change('review', this.state.reviewValue);
  };

  handleCheck = () => {
    const hasGrade = this.props.grade !== 'нет оценки' && this.props.grade != null;
    const sentToReview = (this.state?.resultfiles?.length > 0) || (this.state?.result != null);

    if (hasGrade) {
      // console.log('Запрет всем');
      return true
    } else if (sentToReview) {
      // console.log('Запрет ученику');
      return true
    } else {
      // console.log('Разрешено редактирование');
      return false
    }
  }

  handleToggleReviewModal = (isOpen, index) => values => {
    const { reviews } = this.props;
    const { selectedReview } = this.state;
    this.setState(
      {
        isReviewModalOpened: isOpen,
        selectedReview: isOpen
          ? reviews && reviews[index] && reviews[index]
          : null,
      },
      () => {
        if (this.state.selectedReview && reviews) {
          this.setState({ reviewValue: reviews[index].review || '' });
        }

        if (!isOpen) {
          this.setState({ reviewValue: '', reviewAddFiles: [] });
        }
      }
    );
  };

  removeReview = reviewId => () => {
    const { selectedReview } = this.state;
    this.setState(
      {
        isReviewModalOpened: false,
        selectedReview: null,
      },
      () => {
        this.props.removeReview(selectedReview.project, reviewId);
      }
    );
  };

  handleDownloadFile = (file, type) => () => {
    const { xp_key, downloadFile } = this.props;
    downloadFile(file.file, type, xp_key);
  };

  handleRemoveFile = (file, type) => () =>
    this.props.deleteFile(this.props.id, type, file.file);

  handleUploadFile = type => values => {
    const { id, uploadFile } = this.props;
    const { file } = values;
    file && Object.values(file).forEach(
      item => uploadFile(item, type, id)
    )
  };

  handleUploadReviewFile = values => {
    const { uploadReviewFile } = this.props;
    const { selectedReview, addFiles } = this.state;
    const { reviewFiles } = values;
    addFiles &&
      uploadReviewFile(
        selectedReview.project,
        selectedReview.xp_key,
        addFiles[0]
      );
  };

  handleRemoveReviewFile = values => () => {
    const { removeReviewFile } = this.props;
    const { selectedReview } = this.state;
    const { file } = values;
    file &&
      removeReviewFile(selectedReview.project, selectedReview.xp_key, file);
  };

  renderFile = (file, index) => {
    const { isTeacher } = this.props;
    const { tabIndex } = this.state;

    return (
      <div className="StudentProjectTask__item" key={index}>
        <div className="StudentProjectTask__itemLeft">
          <img alt={'icon'} src={getFileIcon(file.file)} />
          <a
            role="button"
            onClick={this.handleDownloadFile(file, tabsType[tabIndex])} /// TODO
          >
            {file.file}
          </a>
        </div>
        {((isTeacher && this.state.selectedReview) ||
          (isTeacher && tabIndex === 0 && !this.handleCheck()) ||
          (!isTeacher && tabIndex === 1 && !this.hasGrade())) && (
            <img
              src={remove}
              alt="*"
              onClick={
                this.state.selectedReview
                  ? this.handleRemoveReviewFile(file)
                  : this.handleRemoveFile(file, isTeacher ? 'task' : 'result')
              }
            />
          )}
      </div>
    );
  };

  renderAddFile = (file, index) => ( // Предварительный рендер загружаемого файла
    <div className="StudentProjectTask__item" key={index}>
      <div className="StudentProjectTask__itemLeft">
        <img
          alt={'icon'}
          src={fileIcon}
          style={{ maxHeight: '30px' }}
        />
        {file.name}
      </div>
      <img
        src={remove}
        alt="*"
        onClick={() => this.handleRemoveAddFile(index)}
      />
    </div>
  )

  handleRemoveAddFile = (index) => {
    const addFiles = [...this.state.addFiles]
    addFiles.splice(index, 1)
    this.setState(prev => ({ ...prev, addFiles: addFiles }))
  }

  renderFileShort = (file, index) => {
    return (
      <div key={index} className="StudentProjectReview__fileDown">
        <img alt={'icon'} src={getFileIcon(file.file)} />
        <a role="button" onClick={this.handleDownloadFile(file, 'review')}>
          {file.file}
        </a>
      </div>
    );
  };

  renderReviewRow = (data, index) => {
    return (
      <tr
        key={index}
        onClick={
          data &&
          data.mid === this.props.mid &&
          this.handleToggleReviewModal(true, index)
        }
      >
        <td width="70%" className="align-left">
          <p>{data.review.length > 80 ? data.review.slice(0, 80) + '...' : data.review}</p>
        </td>
        <td width="30%">
          {!!data.reviewfiles.length
            ? data.reviewfiles.map(this.renderFileShort)
            : "Нет вложений"
          }
        </td>
      </tr>
    );
  };

  addProjectFiles = (e) => { // несколько файлов кэп
    const addFiles = this.state.addFiles
    const newFiles = e.target.files
    this.setState(prev => ({ ...prev, addFiles: [...addFiles, ...newFiles] }))
  }

  render() {
    const {
      id,
      mid,
      taskfiles,
      resultfiles,
      handleSubmit,
      reviews,
      isTeacher,
      selectedProject,
      handleToggleModal,
    } = this.props;
    const { isReviewModalOpened, tabIndex, selectedReview, addFiles } = this.state;
    return (
      <div>
        <Tabs
          selectedIndex={tabIndex}
          onSelect={tabIndex => this.setState({ tabIndex })}
        >
          <TabList>
            <Tab
              className="table-mark__years_item"
              selectedClassName="active-item"
              key={0}
            >
              Задание
            </Tab>
            {id && (
              <Tab
                className="table-mark__years_item"
                selectedClassName="active-item"
                key={1}
              >
                Работа
              </Tab>
            )}
            {id && (
              <Tab
                className="table-mark__years_item"
                selectedClassName="active-item"
                key={2}
              >
                Рецензия
              </Tab>
            )}
          </TabList>
          <div />

          <div 
            className="TabPanels"
            onClick={(e) => {
              if (selectedProject?.grade !== 'не указано' && selectedProject?.grade != null) {
                e.stopPropagation()
              }
            }}
          >
            <TabPanel key={0}>
              <div className="buttons_panel StudentProjectTask">
                <p className="StudentProjectTask__title">Описание задания, требования к выполнению проекта, работы</p>
                <textarea
                  name="task"
                  cols={30}
                  rows={10}
                  disabled={!isTeacher || this.handleCheck()}
                  value={this.state.taskValue}
                  onChange={(e) => {
                    this.setState({ taskValue: e.target.value });
                  }}
                />
                <div className="StudentProjectTask__list">
                  {/* {!!addFiles.length && addFiles.map(this.renderAddFile)} */}
                  {taskfiles && taskfiles.map(this.renderFile)}

                </div>
                {isTeacher && (
                  <div className="StudentProjectTask__down">
                    {!this.handleCheck() && <FileField 
                      createFile={this.fileLoad} 
                      createFileAt={this.createFileAt} />}
                    {this.state.addFiles ? this.state.addFiles?.[0]?.name : <></>}
                  </div>
                )}
              </div>
            </TabPanel>
            {id && (
              <TabPanel key={1}>
                <div className="buttons_panel StudentProjectTask">
                  <p className="StudentProjectTask__title">Текст</p>
                  <textarea
                    name="result"
                    cols={30}
                    rows={10}
                    disabled={isTeacher || this.hasGrade()}
                    value={this.state.resultValue}
                    onChange={(e) => {
                      this.setState({ resultValue: e.target.value });
                    }}
                  />
                  <div className="StudentProjectTask__list">
                    {resultfiles && resultfiles.map(this.renderFile)}
                  </div>
                  {!isTeacher && !this.hasGrade() && (
                    <div className="StudentProjectTask__down">
                      <FileField createFile={this.fileLoad} createFileAt={this.createFileAt} />
                    </div>
                  )}
                </div>
              </TabPanel>
            )}
            {id && (
              <TabPanel key={2}>
                <Modal
                  isOpen={isReviewModalOpened}
                  onRequestClose={this.handleToggleReviewModal(
                    false,
                    null,
                    true
                  )}
                  contentLabel="SmallModal"
                  className="StudentProjectSmallModal"
                >
                  <div className="PR-StudProjModal StudentProjectAddReview">
                    <textarea
                      name="review"
                      cols={30}
                      rows={10}
                      value={this.state.reviewValue}
                      onChange={(e) => {
                        this.setState({ reviewValue: e.target.value });
                      }}
                    />
                    <div className="StudentProjectTask__list">
                      {selectedReview &&
                        selectedReview.reviewfiles.map(this.renderFile)}
                    </div>
                    <div className="StudentProjectTask__down">
                      <FileField name="reviewFile" createFile={this.fileLoad} createFileAt={this.createFileAt} />
                    </div>
                    <div className="PR-StudProjModalFooter">
                      <div>
                        {selectedReview && (
                          <button onClick={this.removeReview(selectedReview.xp_key)}>
                            Удалить
                          </button>
                        )}
                        <button onClick={this.handleToggleReviewModal(false)}>
                          Отмена
                        </button>
                        <button
                          onClick={() => {
                            const { reviewValue, selectedReview: sr, reviewAddFiles } = this.state;
                            if (reviewValue) {
                              if (sr) {
                                this.props.editReview(sr.project, sr.xp_key, { review: reviewValue });
                              } else {
                                this.props.addReview(this.props.id, { review: reviewValue }, reviewAddFiles);
                              }
                            }
                            this.setState({ isReviewModalOpened: false, selectedReview: null, reviewValue: '', reviewAddFiles: [] });
                          }}
                        >
                          Сохранить
                        </button>
                      </div>
                    </div>
                  </div>
                </Modal>
                <div className="StudentProjectReview__wrapper">
                  <table className="StudentProjectReview">
                    <thead>
                      <tr>
                        <th className="table-title">Отзыв</th>
                        <th className="table-title">Файл рецензии</th>
                      </tr>
                    </thead>
                    <tbody>{reviews.map(this.renderReviewRow)}</tbody>
                  </table>
                </div>

                {isTeacher && (
                  <div className="StudentProjectTask__down">
                    <button className='addTaskButton'
                      onClick={handleSubmit(this.handleToggleReviewModal(true))}
                    >
                      Добавить
                    </button>
                  </div>
                )}
              </TabPanel>
            )}
          </div>
        </Tabs>
        <div className="PR-StudProjModalFooter">
          {selectedProject && selectedProject.id && (
            <section className="grade-selector">
              <SelectField
                name="grade"
                label="Оценка: "
                disabled={!isTeacher || selectedProject.teachermid !== mid}
                options={GRADES}
                style={{ borderBottom: 'none' }}
                onChange={(e, newValue) => this.setState({ gradeValue: newValue })}
              />
            </section>
          )}
          <div>
            <button onClick={handleToggleModal(false, {})}>Закрыть</button>
            <button
              onClick={() => {
                const { addProject } = this.props;
                const { taskValue, resultValue, gradeValue, addFiles } = this.state;
                addProject(false, {}, addFiles, selectedProject && selectedProject.id, !isTeacher && "Черновик")({
                  task: taskValue,
                  result: resultValue,
                  grade: gradeValue,
                });
              }}>
              Сохранить
            </button>
            {!isTeacher && !this.hasGrade() && (
              <button
                onClick={() => {
                  const { addProject } = this.props;
                  const { taskValue, resultValue, gradeValue, addFiles } = this.state;
                  addProject(false, {}, addFiles, selectedProject && selectedProject.id)({
                    task: taskValue,
                    result: resultValue,
                    grade: gradeValue,
                  });
                }}>
                Отправить
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const StudentProjectForm = reduxForm({
  form: 'tasks-files-projects',
})(StudentProject);

export default StudentProjectForm;
